// Translations
import form from '../sections/form/translations/ru'

// Translation: Terms of service > Landing (Russian)
export default Object.freeze({
	sections: { form }
})
